<script>
import LocationIndex from '../index'
export default LocationIndex
</script>